import { formatAddress as renderAddress } from "../../helpers/address";

export const formatAddress = renderAddress;

export const clientName = (client) => {
  if (!client) return "";
  const person = `${client.firstName || ""} ${client.lastName || ""}`.trim();
  const company = (client.companyName || "").trim();
  if (person && company) return `${person} [${company}]`;
  return person || company;
};

export const clientLabel = (client) =>
  client ? `#${client._ref} ${clientName(client)}` : "";

export const money = (value) => (value == null || value === "" ? "" : `€${value}`);

export const dimensionsText = (carpet) => {
  if (!carpet) return "";
  const length = carpet.dimensions ? carpet.dimensions.length : carpet.length;
  const width = carpet.dimensions ? carpet.dimensions.width : carpet.width;
  if (length == null && width == null) return "";
  return `${width || "–"} × ${length || "–"} cm`;
};
